import { clsx } from 'clsx';
import React from 'react';
import styles from '../../product-timeline.module.scss';
import UrlActionView from './url-action';
import { TimelineCommonAction } from '../../interfaces/timeline';
import { useAnalyticEvents } from '../../fake';

const CancelationPolicyView: React.FC<{
  cancellationPolicy: TimelineCommonAction;
}> = ({ cancellationPolicy }) => {
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');

  return (
    <UrlActionView
      url={cancellationPolicy.url}
      newTab={true}
      className={clsx(
        styles.ordersSales__mainRight__link,
        styles['ordersSales__mainRight__steps__step__box--text--875'],
      )}
      onClick={() => {
        sendAnalyticEvent(cancellationPolicy.tracking?.action, { ...cancellationPolicy?.tracking });
      }}
    >
      {cancellationPolicy.title}
    </UrlActionView>
  );
};

export default CancelationPolicyView;
